<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <!-- ========================================== PC ============================================== -->
    <div v-if="this.verticalNavMenuWidth === 'default'" class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!--        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />-->

        <!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

        <!--<vs-button class="px-3 mr-3" color="primary" type="border" @click="openLink">현장 센서 모니터링</vs-button>-->

        <!--        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="UserIcon" @click.stop="handleUserIcon" />-->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />

        <label class="proj-name">{{ projectName }}</label>
        <vs-spacer />

        <!--<search-bar class="mr-4" />-->

        <notification-drop-down />

        <profile-drop-down />
      </vs-navbar>
    </div>
    <!-- ========================================== MOBILE ============================================== -->
    <div v-else class="" :class="classObj">
      <div v-if="$route.meta.topBanner" class="m-top-banner">
        <!-- Header -->
        <div class="flex items-end justify-between" slot="header">
          <!-- 사이드메뉴 상단 로고 이미지 -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/home">
            <img class="m-0 fill-current" :src="sideTopImage" :style="sideTopImageStyle" alt="Digital SHM System"/>
          </router-link>
          <!-- /Logo -->
          <profile-drop-down />
        </div>
        <!-- /Header -->
      </div>
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <label class="proj-name">{{ projectName }}</label>
        <!-- <vs-spacer /> -->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />
        <notification-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import I18nDropDown from "./components/I18n.vue";
import config from "../../../../public/config";
import {mapState} from "vuex";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    isSideMenu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    I18nDropDown,
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
    navbarColorLocal() {

      // projectId를 가지고 있으면 프로젝트 색상으로 변경
      if (this.projectId) {
        if (this.projectInfo && this.projectInfo.project_type === "내부종사자") {
          return "#99C2FF";
        }

        if (this.projectInfo && this.projectInfo.project_type === "도급") {
          return "#E2A6FF";
        }

        if (this.projectInfo && this.projectInfo.project_type === "발주") {
          return "#96E6FF";
        }

        if (this.projectInfo && this.projectInfo.project_type === "중대시민재해") {
          return "#FFC288";
        }
      }

      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { "text-white": (this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") || (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark") };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    projectName() {
      if (this.projectId) {
        return this.projectInfo.field_name;
      }
      return "";
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      selectWorkType: "Coffee",
      sideTopImage: require('@/assets/images/logo/gbmg_snb.svg'),
      sideTopImageStyle: {
        width: "100%",
        height: "40px",
        margin: "0px",
      },
    };
  },
  created() {
    this.loadSideTopImage();
    this.loadSideTopImageStyle()
  },
  async mounted() {
    const _locale = await localStorage.getItem("i18n_locale");
    this.$i18n.locale = _locale;

    if (_locale) {
      const _tempList = _locale.split("_");
      if (_tempList[1] === "construct") {
        this.selectWorkType = "Tool";
      } else if (_tempList[1] === "produce") {
        this.selectWorkType = "Filter";
      } else if (_tempList[1] === "education") {
        this.selectWorkType = "Book";
      } else if (_tempList[1] === "maot") {
        this.selectWorkType = "Coffee";
      }
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },

    handleHomeIcon() {
      if (this.projectId) {
        this.$router.push(`/project/${this.projectId}`).catch(() => {});
      } else {
        this.$router.push("/").catch(() => {});
      }
    },

    /**
     * 사이드 상단 이미지를 localStorage에서만 로드 (API 호출하지 않음)
     * 로그인 시에 미리 저장된 데이터를 사용하여 빠른 렌더링
     * API 호출은 Login.vue에서만 수행됨
     */
    loadSideTopImage() {
      const savedImage = localStorage.getItem(`${this.hostname}_side_top_image`);
      if (savedImage) {
        this.sideTopImage = savedImage;
        console.log('네비게이션바 상단 이미지 로드 (localStorage):', savedImage);
      } else {
        console.log('저장된 사이드 상단 이미지가 없습니다. 기본 이미지를 사용합니다.');
      }
      // 중요: API 호출하지 않음 - 로그인 시에만 업데이트됨
    },

    /**
     * 사이드 상단 이미지 스타일을 localStorage에서만 로드 (API 호출하지 않음)
     * 로그인 시에 미리 저장된 데이터를 사용하여 빠른 렌더링
     * API 호출은 Login.vue에서만 수행됨
     */
    loadSideTopImageStyle() {
      const savedStyle = localStorage.getItem(`${this.hostname}_side_top_image_style`);
      if (savedStyle) {
        try {
          this.sideTopImageStyle = JSON.parse(savedStyle);
          console.log('네비게이션바 상단 이미지 스타일 로드 (localStorage):', this.sideTopImageStyle);
        } catch (e) {
          console.error('사이드 상단 이미지 스타일 파싱 중 오류:', e);
          console.log('기본 스타일을 사용합니다.');
        }
      } else {
        console.log('저장된 사이드 상단 이미지 스타일이 없습니다. 기본 스타일을 사용합니다.');
      }
      // 중요: API 호출하지 않음 - 로그인 시에만 업데이트됨
    },
  },
};
</script>

<style lang="scss" scoped>
.proj-name {
  border-left: 1px solid #dae1e7;
  padding-left: 8px;
  font-size: 18px;
}

.navbar-full {
  header {
    border-radius: 0px;

    label.proj-name {
      flex: 1;
      color: #606060;
      font-weight: 500;
      text-align: center;
      border: none;
      padding: 0;
    }
  }
}

.m-top-banner {
  padding: .8rem 1rem;
  background: #1E0D61;
  color: #fff;
}
.m-top-banner-contents {
  display: flex;
  justify-content: space-between;
}
</style>

